import { render, staticRenderFns } from "./DiscussionsTopicModal.vue?vue&type=template&id=548122d2&scoped=true&"
import script from "./DiscussionsTopicModal.vue?vue&type=script&lang=js&"
export * from "./DiscussionsTopicModal.vue?vue&type=script&lang=js&"
import style0 from "./DiscussionsTopicModal.vue?vue&type=style&index=0&id=548122d2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548122d2",
  null
  
)

component.options.__file = "DiscussionsTopicModal.vue"
export default component.exports